export default __webpack_public_path__ + "static/softwareArchitecture-1edf8bf57e59496824aa2659693b71bd.svg";